<template>
  <div id="head-comparator-couriers-table">
    <div class="d-flex justify-content-end">
        <b-dropdown right text="Right align" variant="link" class="dropdown-auto-width">
        <template #button-content><feather-icon icon="FilterIcon" /> Filtros</template>
        <b-dropdown-form>
          <b-form-checkbox-group
            id="checkbox-columns"
            v-model="selectedColumns"
            :options="optionsColumns"
            value-field="key"
            text-field="label"
            name="checkboxColumns"
            stacked
            checked
            class="dropdown-additional-charges"
          >
          </b-form-checkbox-group>
        </b-dropdown-form>
      </b-dropdown>
    </div>
    <div v-if="!filterTableRows.length"><span class="text-center w-full push-left">{{ 'No se encontraron datos para mostrar' }}</span></div>
    <div class="pagination-controls" v-if="filterTableRows.length">
      <span></span><span>Pág {{ currentPage }}/{{ paginatedFields.length }}</span>
    </div>
    <table-for-couriers
      :filterTableRows="filterTableRows"
      :fields="fields"
      :calculate-page="calculatePage"
      :tableRows="tableRows"
      :isComparator="true"
      :info="data"
    />
  </div>
</template>

<script>
import TableForCouriers from './TableForCouriers.vue'

export default {
  components: { TableForCouriers },
  name: 'TableCouriersCatalog',
  props: ['data'],
  data() {
    return {
      keyTableRender: 0,
      tableRows: [],
      filterTableRows: [],
      fields: [],
      arrayRowsWitchIcons: ['Multibulto', 'Máximo de bultos por envío', 'Seguro incluido', 'Seguro adicional', 'Activación seguro adicional', 'Porcentaje seguro adicional', 'Cobro independiente de indemnización aceptada'],
      arrayPaddingTop: ['Horario de entrega', 'Mínimo de recolección', 'Seguro incluido', 'Información para creación de envío'],
      allFields: [],
      allFieldsSeletected: [],
      paginatedFields: [],
      currentPage: 1,
      pageSize: 3,
      prevButton: {key: 'prevPage', label: '', icon: 'ChevronsLeftIcon', disabled: true, tooltip: 'Anterior'},
      nextButton: {key: 'nextPage', label: '', icon: 'ChevronsRightIcon', disabled: false, tooltip: 'Siguiente'},
      selectedColumns: [],
      optionsColumns: []
    }
  },
  watch: {
    selectedColumns() {
      const selection = []
      this.selectedColumns.flatMap(field => {
        this.allFields.forEach(column => {
          if (field === `${column.carrierCode}-${column.serviceName}`) selection.push(column)
        })
      })
      this.currentPage = 1
      this.paginatedFields = this.paginate(selection)
      this.setFields()
      selection.length ? this.setRows() : this.tableRows = []
      this.calculatePage()
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      this.getFields()
      this.paginatedFields = this.paginate(this.allFields)
      this.optionsColumns = this.allFields.map(el => ({label: `${el.carrierCode} - ${el.serviceName}`, key: `${el.carrierCode}-${el.serviceName}`}))
      this.selectedColumns = this.allFields.map(el => (`${el.carrierCode}-${el.serviceName}`))
      // this.setFields()
    },
    setMockRows() {
      const groups = [
        { 'condiciones_generales': { 'scheduling': 'Horario de entrega', 'delivery_attempts': 'Intentos de entrega', 'max_packages_boolean': 'Multibulto', 'max_packages': 'Máximo de bultos por envío', 'summary': 'Información extra' } },
        { 'recolecciones': { 'min_pickup': 'Mínimo de recolección', 'cut_schedule': 'Horario de corte', 'scheduling_type': 'Agendamiento', 'pickup_schedule': 'Horario de recolección', 'pickup_summary': 'Observaciones' } },
        { 'politicas_de_indemnizacion': { 'insurance_included': 'Seguro incluido', 'insurance_value': 'Tope seguro incluido', 'additional_insurance': 'Seguro adicional', 'insurance_percentage': 'Porcentaje seguro adicional', 'additional_insurance_cap': 'Tope seguro adicional', 'additional_secure_activation': 'Activación seguro adicional', 'independent_compensation_collection_accepted': 'Cobro independiente de indemnización aceptada', 'secure_summary': 'Observaciones' } }
      ]
      if (this.data[0]?.data.carrier?.country_id !== 1) {
        groups.push({ 'condiciones_de_recaudos': { 'delivery_creation_info': 'Información para creación de envío', 'collection_cycle': 'Ciclo de recaudo / conciliación', 'deposit_in_account': 'Abono en cuenta', 'coverage_population': 'Cobertura / Poblaciones', 'observations': 'Observaciones' } })
      }
      return groups
    },
    setFields() {
      if (this.paginatedFields.length) {
        const fields = this.paginatedFields[this.currentPage - 1]
        fields.unshift(this.prevButton)
        fields.unshift({key: 'title', label: ''})
        fields.push(this.nextButton)
        this.fields = fields
      } else {
        this.fields = []
      }
    },
    setRows() {
      const mockRows = this.setMockRows()
      const orderedArray = this.generateOrderedArray(mockRows)
      const rowCourierService = this.getRowCourierService()
      this.tableRows = this.getAllRows(orderedArray, rowCourierService)
      this.filterTableRows = [...this.tableRows]
    },
    getFields() {
      const fields = []
      const filterData = this.data.filter(item => item.data.carrier.logotypes)
      filterData.forEach(item => {
        const carrierCode = item.data.carrier.code
        const serviceName = this.capitalizeWords(item.data.service.name)
        const label = `${this.capitalizeWords(item.data.service.name)}`
        const key = `${item.data.carrier.code}-${item.data.service.code}`
        const logo = item.data.carrier.logotypes[0].url
        fields.push({ key, label, logo, carrierCode, serviceName })
      })
      this.allFields = fields
    },
    generateOrderedArray(data) {
      return data.flatMap(item => {
        const key = Object.keys(item)[0]
        const values = Object.values(item)[0]
        const rows = [{ key, title: this.formatKey(key), status: 'title' }]
        return rows.concat(Object.entries(values).map(([innerKey, innerValue]) => ({ key: innerKey, title: innerValue })))
      })
    },
    getRowCourierService() {
      return this.data.flatMap(item => {
        const row = `${item.data.carrier.code}-${item.data.service.code}`
        const category = item.data.categories[0]
        const categoryKey = Object.keys(category)[0]
        return {[row]: category[categoryKey]}
      })
    },
    getAllRows(array1, array2) {
      const newArray = [...array2].concat([{'icon': {icon: 'ChevronUpIcon'}}])
      return array1.map(item1 => {
        newArray.forEach(obj2 => {
          const [serviceKey, serviceValues] = Object.entries(obj2)[0]
          if (this.arrayRowsWitchIcons.includes(item1.title)) {
            if (item1.title === 'Multibulto') item1[serviceKey] = serviceValues[item1.key] ? { icon: 'check_circle', value: 'false' } : { icon: 'cross_circle', value: 'false' }
            else if (item1.title === 'Máximo de bultos por envío') item1[serviceKey] = serviceValues[item1.key] ? serviceValues[item1.key] : { icon: 'cross_circle', value: 'false' }
            else if (item1.title === 'Seguro incluido') item1[serviceKey] = serviceValues[item1.key] === 'si' ? { icon: 'check_circle', value: 'false' } : { icon: 'cross_circle', value: 'false' }
            else if (item1.title === 'Seguro adicional') item1[serviceKey] = serviceValues[item1.key] && serviceValues[item1.key].toLowerCase() === 'si' ? { icon: 'check_circle', value: 'false' } : serviceValues[item1.key] && serviceValues[item1.key].toLowerCase() === 'no'  ? { icon: 'cross_circle', value: 'false' } : serviceValues[item1.key] ? serviceValues[item1.key] : { icon: 'cross_circle', value: 'false' }
            else if (item1.title === 'Activación seguro adicional') item1[serviceKey] = (serviceValues[item1.key] && serviceValues[item1.key] !== 'No') ? serviceValues[item1.key] : '--'
            else if (item1.title === 'Cobro independiente de indemnización aceptada') {
              item1[serviceKey] = serviceValues[item1.key] === 'true' ? { icon: 'check_circle', value: 'false' } : { icon: 'cross_circle', value: 'false' }
            } else if (item1.title === 'Porcentaje seguro adicional') item1[serviceKey] = (serviceValues[item1.key] && !isNaN(serviceValues[item1.key])) ? item1[serviceKey] = `${serviceValues[item1.key]} ${serviceValues['insurance_percentage_currency']}` : '--'
            else item1[serviceKey] = serviceValues[item1.key]
          } else if (item1.title === 'Condiciones generales' || item1.title === 'Recolecciones' || item1.title === 'Políticas de indemnización' || item1.title === 'Condiciones de recaudos') {
            item1[serviceKey] = serviceValues.icon === 'ChevronUpIcon' ? 'ChevronUpIcon' : ''
          } else if (serviceValues[item1.key]) item1[serviceKey] = serviceValues[item1.key]
          else item1[serviceKey] = '--'
          
          // Convertir la primera letra en mayúscula y el resto en minúscula si es una cadena y no es 'ChevronUpIcon'
          if (typeof item1[serviceKey] === 'string' && item1[serviceKey] !== 'ChevronUpIcon') {
            item1[serviceKey] = item1[serviceKey].charAt(0).toUpperCase() + item1[serviceKey].slice(1).toLowerCase()
          }
        })
        return item1
      })
    },
    paginate(fields) {
      const orderedFields = this.allFields.filter(item => fields.some(f => f.key === item.key))

      return orderedFields.reduce((acc, item, index) => {
        const page = Math.floor(index / this.pageSize)
        if (!acc[page]) acc[page] = []
        acc[page].push(item)
        return acc
      }, [])
    },
    formatKey(key) {
      const keyMap = {
        'condiciones_generales': 'Condiciones generales',
        'recolecciones': 'Recolecciones',
        'politicas_de_indemnizacion': 'Políticas de indemnización',
        'condiciones_de_recaudos': 'Condiciones de recaudos'
      }
      return keyMap[key] || key
    },
    calculatePage(val) {
      if (val === 'prevPage' && this.currentPage > 1) {
        this.currentPage--
      } else if (val === 'nextPage' && this.currentPage < this.paginatedFields.length) {
        this.currentPage++
      }
      // Configurar botón anterior
      this.prevButton.tooltip = this.currentPage === 1 ? '' : 'Anterior'
      this.prevButton.disabled = this.currentPage === 1
      // Configurar botón siguiente
      this.nextButton.tooltip = this.currentPage === this.paginatedFields.length ? '' : 'Siguiente'
      this.nextButton.disabled = this.currentPage === this.paginatedFields.length
      // Actualizar campos visibles
      this.setFields()
    },
    capitalizeWords(str) {
      return str.replace(/(^|\s)\S/g, match => match.toUpperCase())
    }
  }
}
</script>